import React from "react";
import { Clock, Bell, BookOpen, FileText, Scale } from 'lucide-react';
import SEO from '../Components/SEO';

export default function Blog() {
  const topics = [
    { icon: <Scale className="w-5 h-5" />, label: "Legal Analysis" },
    { icon: <FileText className="w-5 h-5" />, label: "Policy Updates" },
    { icon: <BookOpen className="w-5 h-5" />, label: "Compliance Guides" },
  ];

  return (
    <>
    <SEO
      title="Blog & Articles - DPDP Guide"
      description="In-depth legal analysis, compliance guides, and policy updates on India's DPDP Act and data protection framework."
      keywords="DPDP blog, data protection articles, DPDP compliance guides, India privacy law"
    />
    <div
      className="min-h-screen w-full"
      style={{
        background: 'linear-gradient(to bottom, #eff6ff, #ecfeff)',
        fontFamily: 'Inter, Arial, sans-serif',
      }}
    >
      <div className="max-w-4xl mx-auto px-6 sm:px-10 py-6 sm:py-10">
        {/* Header */}
        <div className="mb-10">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1 h-6 rounded bg-blue-700" />
            <span className="text-xs font-semibold uppercase tracking-widest text-blue-700">Legal Insights</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3" style={{ letterSpacing: '-0.01em' }}>
            Blog &amp; Articles
          </h1>
          <p className="text-gray-500 text-base max-w-lg">
            In-depth legal analysis, compliance guides, and policy updates on India's data protection framework.
          </p>
        </div>

        {/* Coming Soon Card */}
        <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
          {/* Top accent bar */}
          <div className="h-1 w-full" style={{ background: 'linear-gradient(to right, #1d4ed8, #0891b2)' }} />

          <div className="px-8 sm:px-14 py-14 sm:py-20 flex flex-col items-center text-center">
            {/* Icon */}
            <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
              style={{ background: 'linear-gradient(135deg, #dbeafe, #cffafe)' }}>
              <Clock className="w-8 h-8 text-blue-700" />
            </div>

            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">Coming Soon</h2>
            <p className="text-gray-500 text-base mb-10 max-w-md leading-relaxed">
              We are preparing authoritative articles on DPDP Act compliance, data principal rights, and regulatory guidance. Check back shortly.
            </p>

            {/* Topic Tags */}
            <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
              {topics.map((t, i) => (
                <span key={i} className="flex items-center gap-2 px-4 py-2 rounded-full border border-blue-100 bg-blue-50 text-blue-800 text-sm font-medium">
                  {t.icon}
                  {t.label}
                </span>
              ))}
            </div>

            {/* Divider */}
            <div className="w-16 h-px bg-gray-200 mb-8" />

            {/* Notify */}
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Bell className="w-4 h-4" />
              <span>Stay tuned for updates</span>
            </div>
          </div>
        </div>

        {/* Footer note */}
        <p className="text-center text-xs text-gray-400 mt-8">
          © 2026 · All content is for informational purposes only and does not constitute legal advice.
        </p>
      </div>
    </div>
    </>
  );
}
